import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabContent", "tabLink", "requiredField"]

  connect() {
    // Show the tab based on the URL hash
    if (window.location.hash) {
      this.tabLinkTargets.forEach(tab => {
        tab.getAttribute("aria-controls") === window.location.hash.substring(1) ? tab.click() : ""
      })
    }
  }

  change(e) {
    const el = e.currentTarget
    const target = document.getElementById(el.getAttribute("aria-controls"))

    // Hide all
    this._hideAll(this.tabLinkTargets, this.tabContentTargets)

    // Then show selected
    el.setAttribute("aria-selected", "true")
    target.removeAttribute("aria-hidden")

    // Set required fields for visible tab only
    this.requiredFieldTargets.forEach(element => {
      element.removeAttribute('required')

      if(target.contains(element)) {
        element.setAttribute('required', true)
      }
    })
  }

  _hideAll(triggers, targets) {
    triggers.forEach(element => {
      element.setAttribute("aria-selected", "false")
    })

    targets.forEach(element => {
      element.setAttribute("aria-hidden", "true")
    })
  }
}
